<template>
  <v-dialog v-if="item.file" v-model="dialog" width="50%" max-width="700px">
    <a slot="activator"><slot></slot></a>
    <v-card>
      <v-toolbar light>
        <v-btn icon @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{item.name}}</v-toolbar-title>
      </v-toolbar>
      <v-container grid-list-lg>
        <v-layout row>
          <v-flex xs6 class="center-align">
            <img :src="item.file.thumbs.medium" class="responsive-img elevation-5">
          </v-flex>
          <v-flex xs6>
            <v-card-text>
              <item-summary :item="item"></item-summary>
              <p></p>
              <div><a :href="item.file.files.preview" target="_blank">Preview File</a></div>
              <div><a :href="item.file.files.cover" target="_blank">Cover File</a></div>
              <div><a :href="item.file.files.content" target="_blank">Content File</a></div>
              <div><a :href="item.file.files.original" target="_blank">Original File</a></div>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import ItemSummary from './item-summary'

export default {
  components: {
    itemSummary: ItemSummary
  },

  props: {
    item: Object
  },

  data () {
    return {
      dialog: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail-modal.vue?668ea593